import React from 'react';
import PropTypes from 'prop-types';
export default function BackIcon(_a) {
    var display = _a.display;
    var className = "display-" + display;
    return (React.createElement("svg", { className: className, height: "10", viewBox: "0 0 14 10", width: "14" },
        React.createElement("path", { d: "M2.998 5.988l2.278 2.304c.39.391.39 1.024 0 1.415s-1.023.391-1.413 0l-3.57-3.597c-.293-.294-.366-.724-.219-1.086-.148-.362-.075-.793.219-1.086l3.57-3.644c.39-.391 1.023-.391 1.413 0s.39 1.024 0 1.415l-2.207 2.28 9.931.036c.552 0 .999.448.999 1 0 .553-.447 1-.999 1z" })));
}
BackIcon.propTypes = {
    display: PropTypes.oneOf(['inline', 'block', 'inlineBlock']),
};
BackIcon.defaultProps = {
    display: 'inline',
};
